import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2,
    Minus,
    CircleMinus,
    CirclePlus} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest, getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizSetUpOuter from "./QuizSetUpOuter";
import HighlightsQuiz from "./HighlightsQuiz";
import FAQsQuiz from "./FAQsQuiz";
import RangeSlider from "../../../UI/RangeSlider";
import AppearanceToggleCard from "../../../UI/AppearanceToggleCard";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const TestConfiguration= ({quizObjectID,setQuizObjectDataBack})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
      const [goNextPopUp, setGoNextPopUp] =useState(false);
     
     const [activeStep, setActiveStep] = useState(0);
     const [activeSubStepOne, setActiveSubStepOne] = useState(3);
     
     const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
     const [activeSubStepThree, setActiveSubStepThree] = useState(0);
     const [activeSubStepFour, setActiveSubStepFour] = useState(0);
     const [activeSubStepFive, setActiveSubStepFive] = useState(0);
     const [titleActive, setTitleActive] = useState(true);
     const [desctiptionActive, setDesctiptionActive] = useState(false);
     const [highlightActive, setHighlightActive] = useState(false);
     const [FAQActive, setFAQActive] = useState(false);
    
    const steps = ([{number:1,name:"Re-attempts"},{number:2,name:"Cut Off "},{number:3,name:"Notes & Reviews"},{number:4,name:"Test Settings"}]);
    const subSteps = [1, 2, 3, 4, 5];
    const subStepOneTotal= 3;
    const subStepTwoTotal= 3;
    const subStepThreeTotal= 3;
    const subStepFourTotal= 3;
    const subStepFiveTotal= 3;
    ;
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
   
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [quizName, setQuizName] = useState("");
        const [reAttempts,  setReAttempts] = useState("");
        const [higlights,  setHiglights] = useState([]);
        const [FAQs,  setFAQs] = useState([]);
        
        const [quizID, setQuizID] = useState("");
        const [quizObject, setQuizObject] = useState({});
   
        const [totalNo, setTotalNo] = useState(80);
        const [allowUserNotes, setAllowUserNotes] = useState();
        const [allowTestRatings, setAllowTestRatings] = useState();
        const [allowTestReview, setAllowTestReview] = useState();
        const [showCalci, setShowCalci] = useState();
        const [autoSubmitMode, setAutoSubmitMode] = useState();
        const [lockSubmitButton, setLockSubmitButton] = useState();
        const [ rangeSliderVisible, setRangeSliderVisible] = useState(false);
       
   const changetotalNumber = ( totalNumber) => {
    // const validityValue= { validityCount:totalNumber,
    //    validityDurationType:itemArr?.validityValue?.validityDurationType}
    
    setTotalNo(totalNumber);
            handleCreateNewMockTest("cutOffPercent",totalNumber)
   };
    const userdata = useSelector((state)=>state?.user?.user);
   useEffect(()=>{
   
   fireGetQuizDataByQuizId()
   
   },[])
   useEffect(()=>{
   
    setAnimate(false);  
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 1000);
 
    return () => clearTimeout(timer); 
    },[titleActive,desctiptionActive,highlightActive,FAQActive])
   const fireGetQuizDataByQuizId=()=>{
   
    setLoader({status:true});
    
      const apiData = dispatch(getQuizDataByQuizId({testName:quizName,type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
          if(response?.quiz){
            
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
      setQuizObject(response?.quiz)
      setTotalNo(response?.quiz?.cutOffPercent?response?.quiz?.cutOffPercent:80);
       setReAttempts(response?.quiz?.testReAttempts)
      setAllowUserNotes( response?.quiz?.allowUserNotes?JSON.parse(response?.quiz?.allowUserNotes):false)
      setAllowTestRatings( response?.quiz?.allowTestRatings?JSON.parse(response?.quiz?.allowTestRatings):false)
      setAllowTestReview( response?.quiz?.allowTestReview?JSON.parse(response?.quiz?.allowTestReview):false)
      setShowCalci( response?.quiz?.showCalci?JSON.parse(response?.quiz?.showCalci):false)
      setAutoSubmitMode( response?.quiz?.autoSubmitMode?JSON.parse(response?.quiz?.autoSubmitMode):false)
      setLockSubmitButton( response?.quiz?.lockSubmitButton?JSON.parse(response?.quiz?.lockSubmitButton):false)
      setLoader({status:false});
      setRangeSliderVisible(true)
  
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
     const handleCreateNewMockTest=(editType,val)=>{
     let SendObject=""
     if(editType=="cutOffPercent"){
        SendObject={cutOffPercent:val,type:"mock",
            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
             if(editType=="testReAttempts"){
                SendObject={testReAttempts:val,type:"mock",
                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                    currentToken:currentToken?currentToken:"",
                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                     }
                     if(editType=="allowUserNotes"){
                        SendObject={allowUserNotes:JSON.stringify(val),type:"mock",
                            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                            currentToken:currentToken?currentToken:"",
                            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                             }
                             if(editType=="allowTestRatings"){
                                SendObject={allowTestRatings:JSON.stringify(val),type:"mock",
                                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                    currentToken:currentToken?currentToken:"",
                                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                     } if(editType=="allowTestReview"){
                                        SendObject={allowTestReview:JSON.stringify(val),type:"mock",
                                            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                            currentToken:currentToken?currentToken:"",
                                            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                             } if(editType=="showCalci"){
                                                SendObject={showCalci:JSON.stringify(val),type:"mock",
                                                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                                    currentToken:currentToken?currentToken:"",
                                                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                                     }
                                                     if(editType=="autoSubmitMode"){
                                                        SendObject={autoSubmitMode:JSON.stringify(val),type:"mock",
                                                            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                                            currentToken:currentToken?currentToken:"",
                                                            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                                             }
                                                             if(editType=="lockSubmitButton"){
                                                                SendObject={lockSubmitButton:JSON.stringify(val),type:"mock",
                                                                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                                                    currentToken:currentToken?currentToken:"",
                                                                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                                                     }
                                                                             
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest(SendObject));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
           if(response?.quiz){
            if(editType!="durationValue"){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
      setSnackbarVisible(true);
              }
       setQuizObject(response?.quiz)
       setTotalNo(response?.quiz?.cutOffPercent?response?.quiz?.cutOffPercent:80);
       setReAttempts(response?.quiz?.testReAttempts)

       setAllowUserNotes( response?.quiz?.allowUserNotes?JSON.parse(response?.quiz?.allowUserNotes):false)
       setAllowTestRatings( response?.quiz?.allowTestRatings?JSON.parse(response?.quiz?.allowTestRatings):false)
       setAllowTestReview( response?.quiz?.allowTestReview?JSON.parse(response?.quiz?.allowTestReview):false)
       setShowCalci( response?.quiz?.showCalci?JSON.parse(response?.quiz?.showCalci):false)
       setAutoSubmitMode( response?.quiz?.autoSubmitMode?JSON.parse(response?.quiz?.autoSubmitMode):false)
       setLockSubmitButton( response?.quiz?.lockSubmitButton?JSON.parse(response?.quiz?.lockSubmitButton):false)
     
      
      setQuizObjectDataBack(response?.quiz)
     setLoader({status:false});
     
     setTimeout(()=>{
       
       setSnackbarVisible(false);
       if(editType=="testReAttempts"){
       setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0); }
        if(editType=="cutOffPercent"){
      
            setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
         
            } if(editType=="higlights"){
      
                setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
                setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
              
                }
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
      


       return <>
       
   
 
   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
       <div   className=" progress-bar-container "style={{position:"relative",zIndex:"99"}}> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclek"  onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
        if(step?.number==1){ setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==2){  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==3){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
          }else if(step?.number==4){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
          }
        }} style={{position:"relative"}} key={step?.number}>
          <div
            
            className={`circlek ${step?.number <= activeStep ? "activek" : ""}` }
            style={{background: `${step?.number ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step?.number ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step?.number ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step?.number ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step?.number ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"95%",height:"5px",background:"rgb(86, 82, 131)",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div>
      <div  className=""style={{marginTop:"40px"}}><div  className=" " style={{background:"#fff",borderRadius:"25px",paddingBottom:"50px"}}>

 {titleActive?
    <div>
    <div  className="ikcraft_login-input-card" style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(10px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease, opacity 1s ease',
       }}>
    <h2 style={{"textAlign":"center",
         transform: animate ? 'translateY(0)' : 'translateY(-20px)',
         opacity: animate ? 1 : 0.5,
         transition: 'transform 1s ease, opacity 1s ease',
       }}> How Many Re-Attempts Are Allowed For This <span className="coloredTextV1" > Test??? </span></h2>
       {rangeSliderVisible && (<RangeSlider  setSliderVal={(val)=>{ setReAttempts(val)}}  sliderVal={reAttempts} />)} </div>
     <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
        <div  >   </div>
      
        <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}><div></div>
    <button onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewMockTest("testReAttempts",reAttempts);}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
      className=" CoursesPreviewTopBtn"  type="submit"
     > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>
    </div>
    </div> </div>:""}
   
{desctiptionActive?
   <div>
   <div  className="ikcraft_login-input-card">
   <h2 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-20px)',
        opacity: animate ? 1 : 0.5,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> Cut Off  <span className="coloredTextV1" > % </span></h2>
      
     <div className="subCourseInfoInnerContainer"> 
       <div >  <h2 style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>   What Is A Cut-Off Precentage For This <span className="coloredTextV1" >Test?</span>  </h2>
           
            </div>
            <div  style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>   <div style={{marginTop: '20px' ,gridTemplateColumns:  "15% 70% 15%" ,height:"80px" }}>
                  {!loader?.statusDurationValue? <Minus  onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)>1?parseInt(totalNo)-1:1)
                     
                   }} style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginRight:"10px",
                         alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}} color="#fff" size={22}/>:<CircleMinus onMouseEnter={handleMouseEnter}
                         onMouseLeave={handleMouseLeave}  onClick={()=>{}} style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginRight:"10px",
                            alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}} color="#fff" size={22}/>}
                     <input onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}  value={parseInt(totalNo)} type="number"
                           onChange={(e)=>{setTotalNo(parseInt(e.target.value)<=100?parseInt(e.target.value):"");}}
                           style={{border:"2px dashed #555555  ",borderRadius:"10px",outline:0,float:"left",width:"55%",
                             padding:"10px",fontSize:"30px",color:"#555555 ",fontWeight:"bolder"}}
                       /> {!loader?.statusDurationValue? <Plus onMouseEnter={handleMouseEnter}
                       onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)<=100?parseInt(totalNo)+1:100)
                         ;
                       }}  style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginLeft:"10px",
                         alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}}  color="#fff" size={22}/>:<CirclePlus onMouseEnter={handleMouseEnter}
                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }}  style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginLeft:"10px",
                           alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}}  color="#fff" size={22}/>}
                         
                         
                         
                         </div>   <h5><span className="coloredTextV1" >Cut Off Must Be less than 100</span></h5> </div>                   
                                                    </div> </div>
    <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
       <div  >   </div>
     
       <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
      
      transition: 'transform 2s ease, opacity 1s ease',
    }}><button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
      setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);}}   className=" CoursesPreviewTopBtn"  type="submit"
   > Back </button>
   <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{ handleCreateNewMockTest("cutOffPercent",totalNo);
    
     }}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
     className=" CoursesPreviewTopBtn"  type="submit"
    > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>
   </div>
   </div> </div> 
 :""}
  {highlightActive? <div>
    <div  className="ikcraft_login-input-card"  style={{"textAlign":"center",paddingTop:"15px",
              transform: animate ? 'translateY(0)' : 'translateY(-10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 1s ease, opacity 1s ease',
            }}>
          
      
      
          <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Allow Users To Take Notes During And After Test. "} </h4></div>
            <Toggle state={allowUserNotes} toggleState={(state)=>{setAllowUserNotes(state) ;handleCreateNewMockTest("allowUserNotes",state)}} />
               </div> 
             
               <div className="gridForWhatsNextAfterYT2"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}>
      
               <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Allow Users To Rate The Test. "} </h4></div>
            <Toggle state={allowTestRatings} toggleState={(state)=>{setAllowTestRatings(state) ;handleCreateNewMockTest("allowTestRatings",state)}} />
               </div> 
               <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Allow Users To Write A Test Review.   "} </h4></div>
            <Toggle state={allowTestReview} toggleState={(state)=>{setAllowTestReview(state) ;handleCreateNewMockTest("allowTestReview",state)}} />
               </div> 
               
      </div>  
      </div>
     <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',background:"#ffffff",fontSize:'12px',marginBottom:'2px',zIndex:"99999999"}}>
        <div  >   </div>
      
        <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"12px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}><button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
       setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
     }}   className=" CoursesPreviewTopBtn"  type="submit"
    > Back </button>
    <button onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} onClick={()=>{ setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
     }}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
      className=" CoursesPreviewTopBtn"  type="submit"
     > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":" Next"} </button>
    </div>
    </div> </div>:""}
 
{FAQActive? <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Test  <span className="coloredTextV1" > Settings </span></h2>
      
      <div className="gridForWhatsNextAfterYT2"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h2 style={{paddingTop:"30px"}}>Allow Calculator During The Test  </h2></div>
            <AppearanceToggleCard animEffect={200} handleCourseSettings={(state)=>handleCreateNewMockTest("showCalci",state)} myCardState={showCalci} setMyCardState={setShowCalci} progress={35} icon={3}  title="Show Calculator"  cursorAlign="" cursorTextVal=""/>
            </div> 

            <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Once Enabled Test Will Be Automitically Submitted when Timer Ends "} </h4></div>
            <Toggle state={autoSubmitMode} toggleState={(state)=>{setAutoSubmitMode(state) ;handleCreateNewMockTest("autoSubmitMode",state)}} />
               </div> 
               <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Once Enabled Users Can't Submit Test Manually Until Timer Ends "} </h4></div>
            <Toggle state={lockSubmitButton} toggleState={(state)=>{setLockSubmitButton(state) ;handleCreateNewMockTest("lockSubmitButton",state)}} />
               </div> 

 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',background:"#ffffff",fontSize:'12px',marginBottom:'2px',zIndex:"99999999"}}>
    <div  >   </div>
  
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"12px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{   setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
    setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
    
  }}   className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Next"} </button>
</div>
</div> </div>
 :""} 
    
 <div>
     </div>
    
    </div>
    </div>
     </>


}
export default TestConfiguration;